<template>
    <div class="cc_banner-wrapper">
        <div class="cc_banner cc_container cc_container--open">
            <div v-bind:class="{'cookiegenerell': true, 'hidden': start}">
                <div class="cc_message">
                    <div class="likeh2">Bitte bestätigen Sie Ihren Antrag!</div>
                    <p></p></div>
                <div class="row-fluid">
                    <div class="form__title form_title_less">
                        <h2>Bitte geben Sie ihr Geburtsdatum ein</h2><br>
                    </div>
                    <div class="fieldset saleslogin">
                        <a-input
                            required
                            label=""
                            v-model="enterbirthday"
                            type="date"
                            yeartype="adult"
                            />
                    </div>
                    <span :class="{'error-block': true, 'hidden': !errorCall}">
                        <span  class="icon set-fas"><span class="glyph" ></span></span>
                        <span class="error"><span class="text">Es ist ein Fehler beim Abrufen Ihrer Daten aufgetreten.</span></span>
                       </span>
                </div>
            </div>


            <div class="row-fluid cc-footer">
                <div class="span8" style="text-align: right;">
                    <div v-if="innerlead.petname == ''" @click="check()" @tab="check()" class="btn btn-primary btn-cookie">Einloggen</div></div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    model: {
        prop: "lead",
        event: "leademit",
    },
    props: {
        lead: {
            type: Object,
            default() {
                return {}
        }},
        hash: {
            type: String,
            default() {
                return ''
        }},
        registry: {
            type: Object,
            default() {
                return {}
        }},
    },
    data: () => ({
        enterbirthday:'2000-10-18',
        innerlead: {petname: ''},
        errorCall: false,
        start: false,
        main: true,
        nec: false,
        market: true,

        external: true,
        setCookies: {},
        allCookies: {'essential': true, 'marketing': true, 'extern': true},
        selectedService: {},
        o_list: {'marketing': {}, 'notwendig': {}, 'extern': {}},
        desc: {'marketing': '', 'notwendig': '', 'extern': ''}
    }),
    beforeCreate: function(){



    },
    mounted: function (){

        this.enterbirthday = new Date();
      this.enterbirthday.setDate(this.enterbirthday.getDate() - 365.25 * 18);
      const match = document.cookie.match('(^|;)\\s*cookieconsent_dismissed\\s*=\\s*([^;]+)')

      if (match) {
        const values = match[2].split(',');

        values.forEach(value => {
          if (value !== undefined) {
            this.setCookies[value] = true;
          }
        })
      }
    },
    methods: {

        check() {

            const path =  process.env.VUE_APP_API_ENDPOINT_PRD + 'checkCustomer' + '?hash=' + this.hash + '&date=' + this.enterbirthday
            /*let data = {
                hash: this.hash,
                date: this.enterbirthday
            }*/

            //const yesno = ['no', 'yes']
            const yesnoB = {'no': false, 'yes': true}
            const yesnoN = {'no': 0, 'yes': 1}
            const country = {'DE': 'Deutschland', 'AT': 'Österreich'}
            const gender = {'male': 'Herr', 'female': 'Frau', 'divers': 'Divers'}
            const pinterval = {"month": "1", "year": "12"}
            const productList = {
                'Tierkrankenschutz': 1,
                'Tierkrankenschutz 24': 4,
                'Tierkrankenschutz Exklusiv': 2,
                'OP-Kostenschutz': 3,
                'OP-Kostenschutz 24': 11,
                'OP-Kostenschutz Exklusiv': 12,
                'Hundehaftpflicht-Schutz': 6,
                'Hundehaftpflicht-Schutz 24': 5,
                'Hundehaftpflicht-Schutz Exklusiv': 7,

            }
           fetch(path, {
                method: 'get',
                //body: JSON.stringify(data) // body data type must match "Content-Type" header
                })
                .then((response) => {
                    return response.json()
                })
                .then((jsonData1) => {

                    if ( jsonData1[1] != 200) {
                        this.errorCall = true;
                        return false
                    }


                    let jsonData = JSON.parse(jsonData1[2])
                    let product = Object.keys(jsonData.products)[0];
                    let startDate = ''

                    if(product.startsWith('Hundehaft')) {
                        startDate = jsonData.tariff.start_date;
                    }
                    else {
                        let yourDate = new Date();
                        yourDate.setDate(yourDate.getDate()+1)
                        const offset = yourDate.getTimezoneOffset()
                        yourDate = new Date(yourDate.getTime() - (offset*60*1000))
                        startDate =  yourDate.toISOString().split('T')[0]
                    }
                    let survey = jsonData.tariff.contract_agreement.includes('NPS')
                    let addagreement = jsonData.tariff.contract_agreement.includes('TEL_SMS')
                    let cross = 0;

                    if(jsonData.isCrossselling !== undefined && jsonData.isCrossselling.length > 1) {
                        for(var i = 0; i < jsonData.isCrossselling.length; i++) {
                            if(productList[product] == jsonData.isCrossselling[i]) {
                                continue;
                            }

                            cross = jsonData.isCrossselling[i];
                            break;
                        }
                    }
// SWAGDIGI-3147
// http://localhost:8080/antrag/?tm=1&brokerID=99901#op-kostenschutz-exklusiv/#bestaetigung

                    this.innerlead = {
                                advancePayment:true,
                                advancePaymentIcon:'<i class="icon-check visible"></i>',
                                advancePerson:true,
                                advancePersonIcon:'<i class="icon-check visible"></i>',
                                advancePet:true,
                                advancePetIcon:'<i class="icon-check visible"></i>',
                                advanceHealth:true,
                                advanceHealthIcon:'<i class="icon-check visible"></i>',
                                advanceTarif:false,
                                advanceTarifIcon:"",
                                addagreement: addagreement,
                                birthday: jsonData.customer.birthdate,
                                breed: jsonData.animal.breed_name,
                                breed_id: jsonData.animal.breed_id,
                                brokerID: jsonData.broker_id,
                                chronic: yesnoN[jsonData.animal.disease_chronic],
                                city: jsonData.customer.address.city,
                                country: country[jsonData.customer.address.country],
                                cssIsHealthy:undefined,
                                email: jsonData.customer.email,
                                file:"",
                                fileInfo:undefined,
                                firstPaymentDate: '',
                                firstname: jsonData.customer.firstname,
                                gender: gender[jsonData.customer.gender],
                                health: yesnoN[jsonData.animal.disease_is_healthy],
                                healthDescription: jsonData.animal.disease_description,
                                hidden:true,
                                iban: (jsonData.payment.bank_data != undefined && jsonData.payment.bank_data.iban != undefined)? jsonData.payment.bank_data.iban: '',
                                iddValidated:false,
                                isHealthy: yesnoB[jsonData.animal.disease_is_healthy],
                                isLs: (jsonData.payment.bank_data != undefined && jsonData.payment.bank_data.iban != undefined)? true: false,
                                jumpToEnd:false,
                                lastname: jsonData.customer.lastname,
                                newsletter:undefined,
                                noPre: jsonData.products[product].no_damage_question,
                                number: jsonData.customer.address.streetnumber,
                                paymentType: ((jsonData.payment.type == 'invoice')? 'ue': 'ls'),
                                paymentinterval: pinterval[jsonData.tariff.paymentperiod],
                                petbirthday: jsonData.animal.birthdate,
                                petcolour: jsonData.animal.color,
                                petgender: ((jsonData.animal.gender == 'male')? 1: 2),
                                petname: jsonData.animal.name,
                                phone: jsonData.customer.phone,
                                place: 4,
                                product: {},
                                productActive: productList[product],
                                productName: product,
                                productSet: productList[product],
                                race: ((jsonData.animal.animal_type == 'dog')? 1: 2),
                                referenceID: jsonData.reference_id,
                                respiratory: yesnoN[jsonData.animal.disease_respiratory],
                                sepa:(jsonData.payment.bank_data != undefined && jsonData.payment.bank_data.sepa != undefined)? true: '',
                                startDate: startDate,
                                street: jsonData.customer.address.street,
                                survey: survey,
                                zip: jsonData.customer.address.zipcode,
                                hash: this.hash,
                                hashR: true,
                                cross: cross,
                                symptoms: jsonData.symptoms,
                                pre_conditions: jsonData.pre_conditions

                    }
                     this.$emit('leademit', this.innerlead)
                })
            }
	}
}
</script>
<style scoped>

        .cc_container {
            width:60% !important;
        }
        .cc_banner-wrapper {
            font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;

        }
        .likeh2, .likeh2 {
            font-family: var(--font-regular);
        }
        .row-fluid {
            width: 100%;
        }
        .hidden-desktop {
            display: none !important;
        }
        @media (min-width: 980px)
        {
            .row-fluid [class*="span"] {
                display: block;
                width: 100%;
                min-height: 34px;
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                float: left;
                margin-left: 2.56410256%;
                *margin-left: 2.51091107%;
            }
            .row-fluid .span6 {
                width: 48.71794872%;
            }
            .row-fluid .span3 {
                width: 23.07692308%;
            }
            .row-fluid .span9 {
                width: 74.35897436%;
            }
            .row-fluid .span10 {
                width: 82.90598291%;
            }
            .row-fluid .span2 {
                width: 14.52991453%;
            }
            .row-fluid [class*="span"]:first-child {
                margin-left: 0;
            }
        }
        @media (min-width: 768px) and (max-width: 979px)
        {
            .row-fluid [class*="span"] {
                display: block;
                width: 100%;
                min-height: 34px;
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                float: left;
                margin-left: 2.76243094%;
                *margin-left: 2.70923945%;
            }
            .row-fluid .span6 {
                width: 48.61878453%;
            }
            .hidden-desktop {
                display: inherit !important;
            }
            .hidden-tablet {
                display: none !important;
            }

        }
        @media (max-width: 767px)
        {
            .hidden-phone {
                display: none !important;
            }
            .hidden-desktop {
                display: inherit !important;
            }
        }


        label, input, button, select, textarea {
            font-size: 14px;
            font-weight: normal;
        }
        label, select, button, input[type="button"], input[type="reset"], input[type="submit"], input[type="radio"], input[type="checkbox"] {
            cursor: pointer;
        }
        input[type="radio"][disabled], input[type="checkbox"][disabled], input[type="radio"][readonly], input[type="checkbox"][readonly] {
            background-color: transparent;
        }
        .btn {
            background-color: #99b8d9;
            background-color: #fff;
            border-color: #004ea0;
            color: #004ea0;
            font-family: var(--font-bold);
            margin-bottom: 0;
            line-height: 24px;
            text-align: center;
            vertical-align: middle;
            cursor: pointer;
            border: 1px solid #004ea0;
            padding: 9px 25px;
            font-weight: normal;
            font-size: 0.9em;
            min-height:0px;
        }
        .btn.btn-primary {
            background-color: #004ea0;
            color: #fff;
            padding: 9px 50px;
            text-transform: uppercase;
            font-family: var(--font-bold);
            font-weight: normal;

        }
        .btn-cookie {
            font-size: 1.1rem;
            text-transform: uppercase;
        }
        table {
            background-color: transparent;
            border-collapse: collapse;
            border-spacing: 0;
        }
        .icon {
            display: inline-block;
            font: normal normal normal 14px/1 FontAwesome;
            font-size: inherit;
            text-rendering: auto;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
        }
        [class^="icon-"]:before, [class*=" icon-"]:before {
            font-family: 'FontAwesome';
            font-style: normal;
            speak: none;
        }
        .icon-info-circle:before {
            content: "\f05a";
        }
        table th {
            border-left: 1px solid transparent;
            border-right: 1px solid transparent;
        }
        .cc_banner-wrapper {
            z-index: 2;
            position: fixed;
            background: rgba(0,0,0,0.7);
            width: 100%;
            height: 100%;
            backdrop-filter: blur(6px);
        }

        .cc_container .cc_btn {
            cursor: pointer;
            text-align: center;
            transition: font-size 200ms;
            line-height: 1em
        }

        .cc_container .cc_message {
            margin: 0;
            padding: 0 0 20px 0;
            line-height: 1.5em;
            font-size: 21px;
            display: block;
        }

        .cc_container .cc_logo {
            display: none;
            text-indent: -1000px;
            overflow: hidden;
            width: 100px;
            height: 22px;
            background-size: cover;
            background-image: url(//cdnjs.cloudflare.com/ajax/libs/cookieconsent2/1.0.10/logo.png);
            opacity: 0.9;
            transition: opacity 200ms
        }

        .cc_container .cc_logo:hover, .cc_container .cc_logo:active {
            opacity: 1
        }

        @media print {
            .cc_banner-wrapper, .cc_container {
                display: none
            }
        }

        .cc_container {
            position: fixed;
            left: 50%;
            top: 50%;
            overflow: hidden;
            padding: 10px;
            width: 1280px;
            transform: translate(-50%, -50%);
        }



        .cc_container .cc_btn {
            padding: 8px 10px;
            background-color: #ccc;
            cursor: pointer;
            transition: font-size 200ms;
            text-align: center;
            display: block;
            max-width: 350px;
            margin-bottom: 5px;
            color: #000;
        }
        .cc_container .span6 a{
            display: block;
            padding: 12px 0px;
        }
        .cc_container .cc_btn.cc_btn_acceptAll{
            background-color: green;
            color: #fff;
        }
        .cc_banner-wrapper.settings .cc_container{
            background-color: #F7F7F7;
        }

        @media screen and (min-width: 768px) {
            .cc_container {
                padding: 20px 60px;
            }

            .cc_container .cc_btn {
                font-size: 1em;
                padding: 8px 15px
            }

        }

        @media screen and (min-width: 992px) {

        }

        .cc_container {
            background: #fff;
            color: #999;
            font-size: 17px;
            box-sizing: border-box;
            border: 1px solid #ccc;
            max-height: 100%;
        }
        .cc_container .scrollable{
            overflow-y: scroll;
            max-height: 400px;
            height: 400px;
        }
        .cc_container ::-moz-selection {
            background: #ff5e99;
            color: #fff;
            text-shadow: none
        }

        .cc_container .cc_btn:hover, .cc_container .cc_btn:active {
            background-color: #004ea0;
            color: #fff
        }

        .cc_container p{
            margin-bottom: 10px;
        }
        .cc_container a.center{
            text-align: center;
            margin: 10px 0 0 0;
            display: block;
        }
        .cc_container table{
            margin-top: 10px;
        }

        /* The switch - the box around the slider */

        .cc_banner .switch {
            position: relative;
            display: inline-block;
            width: 40px;
            height: 20px;
            margin-bottom: 0;
            line-height: 20px;
        }
        .cc_banner .essential .switch{
            line-height: 19px;
        }
        /* Hide default HTML checkbox */
        .cc_banner .switch input {
            opacity: 0;
            width: 0;
            height: 0;
        }

        /* The slider */
        .cc_banner .slider {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #ccc;
            -webkit-transition: .4s;
            transition: .4s;
        }

        .cc_banner .slider:before {
            position: absolute;
            content: "";
            height: 14px;
            width: 14px;
            left: 3px;
            bottom: 3px;
            background-color: white;
            -webkit-transition: .4s;
            transition: .4s;
        }

        .cc_banner input:checked + .slider {
            background-color: #004ea0;
        }

        .cc_banner input:checked + .slider:before {
            -webkit-transform: translateX(20px);
            -ms-transform: translateX(20px);
            transform: translateX(20px);
        }


        /* Rounded sliders */
        .cc_banner .slider.round {
            border-radius: 20px;
        }

        .cc_banner .slider.round:before {
            border-radius: 50%;
        }
        .cc_banner .likeh2{
            color: #004ea0;
            margin-bottom: 40px;
            font-size: 1.714em;
            line-height: 1.167em;
        }
        .cc_banner .cc_message .likeh2{
            margin-bottom: 10px;
            margin-top: 10px;
        }
        .cc_banner .span3 .likeh3{
            border-bottom: 1px solid #ddd;
            padding: 10px 0;
            margin: 0;
            cursor: pointer;
            font-size: 1.429em;
            line-height: 1.2em;
        }
        .cc_menu .span3 .likeh3:hover,
        .cc_menu .span3 .active .likeh3{
            color: #004ea0;
        }
        .cc_menu{
            padding-bottom: 10px;
        }
        .cc_menu .span9{
            border-left: 1px solid #ddd;
            padding-left: 20px;
            padding-right: 10px;
            margin-left: 10px !important;
        }
        .cc-footer{
            text-align: left;
            clear: both;
            background: #fff;
            padding: 20px 60px 20px 60px;
            position: relative;
            margin-left: -60px;
            margin-bottom: -20px;
        }
        .cc_banner .scrollable table{
            margin: 0;
        }
        .cc_banner .scrollable .span10{
            color: #004ea0;
        }
        .cc_banner .scrollable .span2{
            text-align: right;
        }
        .cc_banner .scrollable td{
            padding: 10px 0;
            border: 0 none;
            border-bottom: 1px solid #ddd;
        }
        .cc_banner .scrollable td:first-child{
            color: #004ea0;
        }
        .cc_banner .scrollable .cc_cookiegroup td:first-child{
            width: 90%;
        }
        .cc_banner .scrollable .cc_cookiegroup td:nth-child(2){
            text-align: right;
            padding-right: 5px;
        }
        .cc_banner .scrollable .cc_cookiegroup td:nth-child(3){
            text-align: right;
            padding-right: 0px;
        }
        .cc_banner .scrollable table{
            margin: 2%;
            max-width: 96%;
            font-size: 14px;
        }
        .cc_banner .scrollable table.cc_cookiegroup{
            margin: 0;
            max-width: 100%;
            font-size: 17px;
        }

        .cc_banner .scrollable td:nth-child(2) i{
            font-size: 22px;
            cursor: pointer;
        }
        .cc_banner .scrollable th{
            text-align: left;
            border-bottom: 1px solid #ddd;
        }
        .cc-footer .btn{
            margin-left: 10px;
        }
        .cc-config-link{
            line-height: 40px;
        }

        .cc-start-btns .row-fluid .span6.first{
            margin-left: 0px;
        }
        .cc_banner .scrollable table.cookietable{
            font-size: 12px;
        }
        .cookietable td:nth-child(1){
            width: 12%;
        }
        .cookietable td:nth-child(2){
            width: 8%;
        }
        .cookietable td:nth-child(3){
            width: 25%;
        }
        .cookietable td:nth-child(4){
            width: 15%;
        }
        .cookietable td:nth-child(5){
            width: 30%;
        }
        .cookietable td:nth-child(6){
            width: 10%;
        }
        .cookietable td{
            vertical-align: top;
        }
        .etrusted-badge-container--left {
            right: 10px !important;
        }
        @media (max-width: 1300px)
        {
            .cc_container {
                max-width: 100%;
            }
        }

        @media (min-width:1025px) and (max-width:1033px)
        {
            .row-fluid .span6.cc-start-btns  a{
                font-size:0.8em;
            }
        }

        @media (max-width: 1024px)
        {
            .row-fluid .span8.cc-config-link{
                width: 50%;
                margin: 0;
            }
            .row-fluid .span6.cc-start-btns{
                width: 50%;
                margin: 0;
            }
            .row-fluid .span6.cc-start-btns .btn{
                margin-left: 10px;
            }
            .cc_container {
                position: fixed;
                left: 0;
                bottom: 200px;
                overflow: hidden;
                padding: 10px;
                width: 100%;
                max-width: 100%;
                transform: translate(0, 0);
                top: auto;
            }

        }
        @media (max-width: 979px)
        {
            .row-fluid .span6.cc-config-link {
                width: 50%;
                margin: 0;
            }

            .row-fluid .span6.cc-start-btns {
                width: 50%;
                margin: 0;
            }
            .cc-footer .btn{
                width: 100%;
                margin-top: 10px;
                margin-left: 0;
                box-sizing: border-box;
            }
        }

        @media (min-width:768px) and (max-width: 979px)
        {
            .row-fluid .span6.cc-start-btns  a{
                font-size:0.8em;
            }
        }
        @media (max-width: 767px) {
            .cc_banner .scrollable table {
                font-size: 11px;
                line-height: 120%;
            }
            .row-fluid .span6.cc-start-btns .btn{
                margin-left: 0px;
                width:100%;
            }

            .row-fluid .span6.cc-config-link{
                width: 100%;
                margin: 0;
            }
            .row-fluid .span6.cc-start-btns{
                width: 100%;
                margin: 0;
            }

            .cc-start-btns .btn{
                margin-top: 10px;
            }
            .cc_menu .span9 {
                border-left: 0 none;
                padding-left: 0px;
                padding-right: 10px;
                margin-left: 0px !important;
            }
            .cc_container .scrollable {
                overflow-y: scroll;
                max-height: 200px;
                height: 200px;
            }
            .cc_banner .likeh2{
                margin-bottom: 5px;
            }
            .externmenu .likeh3,
            .marketingmenu .likeh3,
            .essentialmenu .likeh3{
                border-bottom: 1px solid #ddd;
                padding: 10px 0;
                margin: 0;
                cursor: pointer;
                font-size: 1.429em;
                line-height: 1.2em;
                width: 100%;
                position: relative;
            }
            .marketingmenu .likeh3::after,
            .essentialmenu .likeh3::after,
            .externmenu .likeh3::after{
                content: '\f107';
                font-family: FontAwesome;
                position: absolute;
                right: 10px;
            }
            .marketingmenu.active .likeh3::after,
            .essentialmenu.active .likeh3::after,
            .externmenu.active .likeh3::after{
                content: '\f106';
                font-family: FontAwesome;
                position: absolute;
                right: 10px;
            }

            .externmenu.active .likeh3,
            .marketingmenu.active .likeh3,
            .essentialmenu.active .likeh3{
                /*color: #004ea0;*/
            }
            .scrollable p{
                margin-top: 10px;
            }

            .row-fluid.cc-accept-area .span10{
                width: 70%;
                float: left;
            }
            .row-fluid.cc-accept-area .span2{
                width: 30%;
                float: left;
            }
            .cc_banner .scrollable .cc_cookiegroup td:first-child{
                width: 80%;
            }
            .cc-footer .btn{
                width: 100%;
                margin-top: 10px;
                margin-left: 0;
                box-sizing: border-box;
            }

        }
        @media (max-width: 450px){
            .cc_container .cc_message{
                font-size: 14px;
            }
            .cookiesettings .likeh2{
                text-align: center;
            }
            .cc_banner .scrollable table.cookietable{
                font-size: 10px;
            }
        }
        .icon-remove::before, .icon-close::before, .icon-times::before {
            content: "\f00d";
        }
</style>
<style>
.saleslogin .input-control .wrapper {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
}
.error {
  color: red !important;
  margin-left:10px;

}
.error-block {
  color: red !important;
  position:relative;
  top:5px;

}
</style>
